// components/CategoryForm/CategoryForm.tsx
import React, { useState } from 'react';
import {
  Box,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  Typography,
  Paper,
} from '@mui/material';
import { CategoryFormData, CategoryFormProps } from '../../../types/services.types';
import { useGetAllServices } from '../../../api/service';
import { categoryFormStyles } from './CategoryForm.styles';

const CategoryForm: React.FC<CategoryFormProps> = ({ category, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState<CategoryFormData>({
    name: category?.name || '',
    service_ids: category?.services?.map(s => Number(s.id)) || []
  });

  const { services = [] } = useGetAllServices();

  const handleSubmit = (): void => {
    onSubmit(formData);
  };

  const handleServiceToggle = (serviceId: string | number): void => {
    const numericId = Number(serviceId);
    setFormData(prev => ({
      ...prev,
      service_ids: prev.service_ids.includes(numericId)
        ? prev.service_ids.filter(id => id !== numericId)
        : [...prev.service_ids, numericId]
    }));
  };

  return (
    <Box sx={categoryFormStyles.container}>
      <Box sx={categoryFormStyles.fieldContainer}>
        <Typography variant="body2" sx={categoryFormStyles.label}>
          Category Name
        </Typography>
        <TextField
          fullWidth
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder="Enter category name"
          variant="outlined"
          size="small"
          sx={categoryFormStyles.textField}
        />
      </Box>

      <Box sx={categoryFormStyles.fieldContainer}>
        <Typography variant="body2" sx={categoryFormStyles.label}>
          Associated Services
        </Typography>
        <Paper sx={categoryFormStyles.servicesList}>
          <FormGroup>
            {services.map(service => (
              <FormControlLabel
                key={service.id}
                control={
                  <Checkbox
                    checked={formData.service_ids.includes(Number(service.id))}
                    onChange={() => handleServiceToggle(service.id)}
                    size="small"
                  />
                }
                label={
                  <Typography variant="body2">
                    {service.name}
                  </Typography>
                }
                sx={categoryFormStyles.checkboxLabel}
              />
            ))}
          </FormGroup>
        </Paper>
      </Box>

      <Box sx={categoryFormStyles.buttonContainer}>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={categoryFormStyles.submitButton}
          fullWidth
        >
          {category ? 'Update' : 'Create'} Category
        </Button>
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={categoryFormStyles.cancelButton}
          fullWidth
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default CategoryForm;